import { Combobox } from '@headlessui/react';
import React from 'react';

type SearchboxListProps = {
    children?: React.ReactNode;
    className?: string;
};

export function SearchboxList(props: SearchboxListProps) {
    const { children, className = '' } = props;
    return (
        <Combobox.Options
            className={`${className} mb-0 last-child:mb-0 select-none`}
            static
        >
            {children}
        </Combobox.Options>
    );
}
